import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import keymaster from 'keymaster';

class SubmitModal extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            preventRefocus: false
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        ReactDOM.findDOMNode(this.refs.closeButton).focus();
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    componentWillUnmount = () => {
        if (this.props.returnKeymaster)
            this.props.returnKeymaster();
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    handleRefocus = (event) => {
        if (event.nativeEvent.relatedTarget && event.nativeEvent.relatedTarget.type === "button")
            ReactDOM.findDOMNode(this.refs.submitButton).focus();
    }

    handleSubmit = () => {
        this.props.handleSubmit();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onRequestHide={() =>{}} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div ref="modalBody" className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">Submit Timesheet</h4>
                        </div>
                        <div ref="modalBody" className="modal-body">
                            <h4>
                            Currently logged hours are equal to your weekly qouta and ready for submit. <br/><br/>
                            Submitted timesheets can not be edited. <br/><br/>
                            Submit timesheet?
                            </h4>
                        </div>
                        <div className="modal-footer">
                            <button title="Submit timesheet" ref="submitButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleSubmit}>Yes</button>
                            <button title="Do not submit timesheet" ref="closeButton" type="button" className="btn btn-default btn-large" onBlur={this.handleRefocus} onClick={this.handleClose}>Close</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

SubmitModal.propTypes = {
    returnKeymaster: PropTypes.func,
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        error: state.users.error
    };
};

export default connect(
    mapStateToProps
)(SubmitModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/SubmitModal.js
 **/